import { Dialog, DialogContent } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import React from 'react';

const simpleDialogCommunClasses = makeStyles(() => ({
  SimpleDialogRoot: {
    zIndex: '1050 !important',
  },
  SimpleDialogContainer: {
    padding: 16,
    display: 'flex',
  },
  SimpleDialogPaper: {
    margin: 0,
    flex: '1 1 auto',
    height: '100%',
  },
  SimpleDialogPaperFullScreen: {
    borderRadius: '8px !important',
  },
  SimpleDialogPaperScrollPaper: {
    maxHeight: '100%',
  },
  SimpleDialogContentRoot: {
    padding: 0,
    margin: 0,
    '&:first-child': {
      paddingTop: 0,
    },
  },
  SimpleDialogPaperWidthSm: {
    maxWidth: 685,
  },
}));

const SimpleDialogCommun = ({ fullScreen, open, onClose = () => {}, maxWidth, paperClass, children, container }) => {
  const classes = simpleDialogCommunClasses();

  return (
    <Dialog
      open={open}
      fullScreen={fullScreen}
      classes={{
        root: classes.SimpleDialogRoot,
        container: clsx(classes.SimpleDialogContainer, container),
        paper: clsx(classes.SimpleDialogPaper, maxWidth, paperClass),
        paperFullScreen: classes.SimpleDialogPaperFullScreen,
        paperScrollPaper: classes.SimpleDialogPaperScrollPaper,
        paperWidthSm: !fullScreen ? classes.SimpleDialogPaperWidthSm : '',
      }}
      onClose={onClose}
    >
      <DialogContent>{children}</DialogContent>
    </Dialog>
  );
};

export default SimpleDialogCommun;
